import { Text } from "@ecco/ui/text";
import { Button } from "@ecco/ui/button";
import { useStore } from "@store/index";
import type { ButtonHTMLAttributes } from "react";

type Props = {
    testId?: string;
    headerText: string;
    isLoading?: boolean;
} & ButtonHTMLAttributes<HTMLButtonElement>;

const StepSubmitButton = ({ testId, headerText, isLoading = false, ...rest }: Props) => {
    const isLocked = useStore((state) => state.data.isLocked);

    return (
        <Button
            variant={"solid"}
            isLoading={isLocked || isLoading}
            isDisabled={isLocked}
            type="submit"
            minW={{ base: "100%", md: "186px" }}
            data-testid={testId}
            {...rest}
        >
            <Text fontSize={["mobileBodyTextSmall", "desktopBodyTextSmall"]} fontWeight="bold">
                <span>{headerText}</span>
            </Text>
        </Button>
    );
};

export default StepSubmitButton;
